import { useEffect, useState } from "react";
import { useAuth } from "../context/AppContext";
import { Navigate, Link } from "react-router-dom";

export function Account() {
  const { user, logout, loading, authApi } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!user) return;
    authApi.get("/orders/me")
      .then(r => setOrders(r.data)).catch(() => {});
  }, [user, authApi]);

  if (loading) return <div className="min-h-screen bg-black pt-32 text-center text-white/40 font-mono tracking-[0.25em] uppercase">Loading</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-black pt-28 pb-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-start justify-between flex-wrap gap-6">
          <div>
            <div className="bl-eyebrow text-[color:var(--bl-gold)]">Inner Circle</div>
            <h1 className="bl-heading text-white text-5xl mt-4">{user.full_name}</h1>
            <div className="mt-3 font-mono text-white/50 text-sm">{user.email}</div>
          </div>
          <button data-testid="account-logout" onClick={logout} className="bl-btn">Sign Out</button>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {[
            ["Member Since", new Date(user.created_at).toLocaleDateString()],
            ["Status", user.is_member ? "Active" : "—"],
            ["Orders", String(orders.length)],
          ].map(([k, v]) => (
            <div key={k} className="bl-glass border border-white/5 p-6">
              <div className="bl-eyebrow">{k}</div>
              <div className="font-display text-white text-2xl mt-3">{v}</div>
            </div>
          ))}
        </div>

        <div className="mt-14">
          <div className="flex items-end justify-between mb-6">
            <div>
              <div className="bl-eyebrow">/ History</div>
              <h2 className="bl-heading text-white text-3xl mt-3">Orders</h2>
            </div>
            <Link to="/shop" className="bl-btn">Continue Shopping</Link>
          </div>
          {orders.length === 0 ? (
            <div className="border border-white/5 p-10 text-center text-white/50">No orders yet.</div>
          ) : (
            <div className="border border-white/5 divide-y divide-white/5">
              {orders.map(o => (
                <div key={o.session_id} className="p-5 grid grid-cols-4 items-center gap-4">
                  <div className="font-mono text-xs text-white/50 truncate">{o.session_id.slice(-12)}</div>
                  <div className="text-white/80 text-sm truncate">{(o.items||[]).map(i=>`${i.name} ${i.strength} ×${i.quantity}`).join(", ")}</div>
                  <div className="font-mono text-xs text-white/50 uppercase tracking-[0.2em]">{o.payment_status}</div>
                  <div className="text-right font-display text-white">A${(o.amount||0).toFixed(2)}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
